module.exports = __webpack_public_path__ + "static/media/AAbyPO-FullColor-logo.68201685.svg";